import styled from 'styled-components'
import { devices } from '../styles/mediaQueries'

export const Section = styled.section`
  padding: ${({ padding }) => (padding ? padding : '0rem 13rem')};
  position: relative;
  @media ${devices.tabland} {
    padding: 0rem 8rem;
  }

  @media ${devices.tabport} {
    padding: 0rem 2rem;
  }

  @media screen and (min-width: 1440px) {
    width: 1440px;
    margin: auto;
  }
`

export const YellowBordered = styled.div`
  border: 1px solid #f1bc11;
  padding: 6rem 10rem;
  margin: 6rem 0rem;

  @media ${devices.tabland} {
    padding: 6rem 6rem;
  }
  @media ${devices.tabport} {
    padding: 6rem 6rem;
  }
  @media ${devices.phone} {
    padding: 6rem 2rem;
  }
`
